// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password{
  position:relative;
  display:block;
}

  .password input.input__control{
    width:calc(100% - 30px);
  }

  .password__visibility{
    position:absolute;
    top:12px;
    right:0;
    padding:0.25rem;
    cursor:pointer;
    background:none;
    border:0;
  }

  .password__visibility--hidden .password__make-visible{
        display:block;
      }

  .password__visibility--hidden .password__make-invisible{
        display:none;
      }

  .password__visibility--visible .password__make-visible{
        display:none;
      }

  .password__visibility--visible .password__make-invisible{
        display:block;
      }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
